/**
 * 📦 COMPOSANT : sellerie-app/frontend/src\components\Beta\FeedbackButton.tsx
 * Ce composant est utilisé dans d'autres pages de l'application
 */

/**
 * Bouton flottant pour donner un feedback rapidement
 * Visible sur toutes les pages authentifiées
 */
import React from 'react';

interface FeedbackButtonProps {
  onClick: () => void;
}

const FeedbackButton: React.FC<FeedbackButtonProps> = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="fixed bottom-6 right-6 bg-blue-600 hover:bg-blue-700 text-white rounded-full p-4 shadow-lg transition-all duration-200 hover:scale-110 z-40 group"
      aria-label="Donner mon avis"
      title="Donner mon avis sur l'application"
    >
      <div className="flex items-center space-x-2">
        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
          />
        </svg>
        <span className="hidden group-hover:inline-block text-sm font-medium whitespace-nowrap">
          Feedback
        </span>
      </div>
    </button>
  );
};

export default FeedbackButton;
